import instance from "./axios";
import baseUrl from "@/env";

export async function getallcourses() {
  const res = await instance.get(
    `${baseUrl}/courseManager/getallcourse?catalogID`
  );

  return res.data;
}
export async function getCollegeSubModules(collegeID) {
  const res = await instance.get(
    `${baseUrl}/teachCollege/getCollegeSubModules?collegeID=${collegeID}`
  );

  return res.data;
}
export async function getchapters(courseid) {
  const res = await instance.get(
    `${baseUrl}/courseManager/getchapters?courseSerialnumber=${courseid}`
  );

  return res.data;
}

export async function getCourseByStudent() {
  const res = await instance.get(`${baseUrl}/courseManager/getCourseByStudent`);

  return res.data;
}

//获取课程知识点下所有题目
export async function getAllQuestion(courseid, knowledgeid) {
  const res = await instance.get(
    `${baseUrl}/courseManager/getQuestionList?courseSerialnumber=${courseid}&knowledgeSerialnumber=${knowledgeid}`
  );
  return res.data;
}

//获取经典题高职知识点树及题目数量统计
export async function getClassicQuestionKnowledgeTree() {
  const res = await instance.get(
    `${baseUrl}/courseManager/getClassicQuestionKnowledgeTree`
  );
  return res.data;
}

//获取经典题题目列表
export async function getClassicQuestionList(
  vocationalKnowledgeCode,
  difficultyLevel,
  qtype
) {
  const params = [];
  if (vocationalKnowledgeCode) {
    params.push(
      `vocationalKnowledgeCode=${encodeURIComponent(vocationalKnowledgeCode)}`
    );
  }
  if (
    difficultyLevel !== undefined &&
    difficultyLevel !== null &&
    difficultyLevel !== ""
  ) {
    params.push(`difficultyLevel=${difficultyLevel}`);
  }
  if (qtype && qtype !== "All") {
    params.push(`qtype=${encodeURIComponent(qtype)}`);
  }
  const queryStr = params.length > 0 ? `?${params.join("&")}` : "";
  const res = await instance.get(
    `${baseUrl}/courseManager/getClassicQuestionList${queryStr}`
  );
  return res.data;
}

